import * as store from '@attain-apps/fe/web/main/lib/store'

import type { ClipboardService } from '../clipboard.service'
import type * as models from '../models'

import { State } from './state'

/**
 * Core actions for this {@link Router}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig(service: ClipboardService) {
  return {
    /* eslint-disable sort-keys */
    /** TODO:  */
    openDialog: store.actions.standalone({
      data: ({
        dialogConfig,
        paster,
      }: {
        dialogConfig?: models.DialogConfig
        paster?: models.Paster
      }) => ({
        dialogConfig,
        paster,
      }),
      reducerDeprecated: (state, { dialogConfig, paster }) => ({
        ...state,
        dialogConfig,
        paster,
      }),
    }),
    /** TODO:  */
    closeDialog: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => ({
        ...state,
        dialogConfig: undefined,
        pasteClassRef: undefined,
        callback: undefined,
      }),
    }),
    /** TODO:  */
    pasteSelected: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        success: ({ state }) => ({
          ...state,
          dialogConfig: undefined,
          pasteClassRef: undefined,
          callback: undefined,
        }),
      },
    }),
    copy: store.actions.standalone({
      data: ({
        item,
        items,
      }: ExactlyOneOf<{
        readonly item: models.Item<any>
        readonly items: readonly models.Item<any>[]
      }>) => ({ items: items ?? [item] }),
      reducerDeprecated: (state, { items }) =>
        State.Lookup.insert(state, ...items),
    }),
    remove: store.actions.standalone({
      data: ({
        id,
        ids,
        selected,
      }: ExactlyOneOf<{
        readonly id: string
        readonly ids: string[]
        selected: true
      }>) =>
        (selected
          ? {
              selected,
            }
          : {
              ids: ids ?? [id],
            }) satisfies ExactlyOneOf<{
          readonly ids: string[]
          selected: true
        }>,
      reducerDeprecated: (state, { ids, selected }) =>
        selected
          ? State.Lookup.removeSelected(state)
          : State.Lookup.remove(state, ...ids),
    }),
    addSelection: store.actions.standalone({
      data: ({
        id,
        ids,
      }: ExactlyOneOf<{ readonly ids: string[]; readonly id: string }>) => ({
        ids: ids ?? [id],
      }),
      reducerDeprecated: (state, { ids }) => State.addSelection(state, ...ids),
    }),
    setSelection: store.actions.standalone({
      data: ({
        id,
        ids,
      }: ExactlyOneOf<{ readonly ids: string[]; readonly id: string }>) => ({
        ids: ids ?? [id],
      }),
      reducerDeprecated: (state, { ids }) => State.setSelection(state, ...ids),
    }),
    removeSelection: store.actions.standalone({
      data: ({
        id,
        ids,
      }: ExactlyOneOf<{ readonly ids: string[]; readonly id: string }>) => ({
        ids: ids ?? [id],
      }),
      reducerDeprecated: (state, { ids }) =>
        State.removeSelection(state, ...ids),
    }),
    releaseSelection: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => State.releaseSelection(state),
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
